
import { Contract, CopyrightFAQ } from './types';

// Contract templates data
export const contractTemplates: Contract[] = [
  {
    id: 1,
    title: "Recording Contract",
    description: "Standard agreement between artist and record label",
    premium: false,
    lastUpdated: "May 2023",
    compatibleWith: "US, UK, EU Law"
  },
  {
    id: 2,
    title: "Music Producer Agreement",
    description: "Contract for hiring a producer for your recording project",
    premium: false,
    lastUpdated: "June 2023",
    compatibleWith: "US, UK, EU Law"
  },
  {
    id: 3,
    title: "Songwriter Collaboration",
    description: "Agreement for splitting rights in co-writing situations",
    premium: false,
    lastUpdated: "August 2023",
    compatibleWith: "US, Canada, UK Law"
  },
  {
    id: 4,
    title: "Sync License Agreement",
    description: "License music for use in film, TV, or other media",
    premium: true,
    lastUpdated: "September 2023",
    compatibleWith: "International Use"
  },
  {
    id: 5,
    title: "Band Partnership Agreement",
    description: "Define the legal structure and member responsibilities",
    premium: false,
    lastUpdated: "July 2023",
    compatibleWith: "US, UK, Canada Law"
  },
  {
    id: 6,
    title: "Music Publishing Agreement",
    description: "Contract between songwriter and music publisher",
    premium: true,
    lastUpdated: "April 2023",
    compatibleWith: "International Use"
  }
];

// Copyright FAQs data
export const copyrightFAQs: CopyrightFAQ[] = [
  {
    question: "Do I need to register my music to have copyright protection?",
    answer: "No, your music is automatically protected by copyright as soon as it's created and fixed in a tangible form. However, registration provides important benefits including the ability to sue for infringement and seek statutory damages."
  },
  {
    question: "How long does copyright protection last for music?",
    answer: "In most countries, copyright protection for music lasts for the life of the author plus 70 years after their death. For works made for hire, the protection is typically 95 years from publication or 120 years from creation, whichever is shorter."
  },
  {
    question: "What's the difference between copyright and a trademark?",
    answer: "Copyright protects original creative works like music, lyrics, and recordings. Trademarks protect brand names, logos, and slogans that identify your music services or products in the marketplace."
  },
  {
    question: "Can I use samples from other songs in my music?",
    answer: "Using samples generally requires permission from both the copyright owner of the sound recording and the copyright owner of the underlying composition, regardless of how short the sample is. Failure to clear samples can lead to copyright infringement claims."
  }
];
